import { Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { useStyles } from '../styles';

interface AdminActionHintProps {
  isToolAdmin: boolean;
  className?: string;
}

export function AdminActionHint({
  isToolAdmin,
  className,
}: AdminActionHintProps) {
  const classes = useStyles();

  if (isToolAdmin) return null;

  return (
    <Typography
      component="p"
      variant="caption"
      className={`${classes.adminActionHint}${
        className ? ` ${className}` : ''
      }`}
    >
      <InfoOutlinedIcon
        aria-hidden="true"
        className={classes.adminActionHintIcon}
      />
      <span className={classes.adminActionHintText}>
        Only this APM's primary business/support owners, APM admins can perform
        this action.
      </span>
    </Typography>
  );
}
